exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-20277167] .progress-loading .el-progress-bar__outer{background:repeating-linear-gradient(-45deg,#fff .5px 10px,#ebeef5 0 40px) 0/200% 100%;-webkit-animation:i3-20277167 10s linear infinite;animation:i3-20277167 10s linear infinite}@-webkit-keyframes i3-20277167{to{background-position:100%}}@keyframes i3-20277167{to{background-position:100%}}", ""]);

// exports
